.userMenu {
  // TODO: use stronger selector instead of !important
  &_username {
    padding: 18px 24px 0 !important;
    word-break: break-all;
  }

  &_link {
    margin: 0 24px;
  }

  &_logoutButton {
    cursor: pointer;
    padding: 15px 24px !important;
  }

  &_additionalLinkContent {
    padding: 15px 24px;
  }
}
